import { mapState } from "vuex";
export const currencyMixin = {
  computed: {
    ...mapState('currency', ['currency', 'ratio']),
  },
  methods: {
    currencyDisplay (value, recalculate = true, changeCurrency = false) {
      const calculatedValue = recalculate ? value / this.ratio : value;
      const currentCurrency = changeCurrency ?  "PLN" : this.currency;
      return new Intl.NumberFormat("pl-PL", {
          style: "currency",
          currency: currentCurrency,
      }).format(calculatedValue);
    },
  }
}
